import { GetOneInspectionInDto, GetOneInspectionOutDto } from '../../../types/inspection.dto'

export const GET_ONE_INSPECTION = 'GET_ONE_INSPECTION'
export const GET_ONE_INSPECTION_SUCCESS = 'GET_ONE_INSPECTION_SUCCESS'
export const GET_ONE_INSPECTION_ERROR = 'GET_ONE_INSPECTION_ERROR'
export const RESET_GET_ONE_INSPECTION = 'RESET_GET_ONE_INSPECTION'

export interface GetOneInspection {
  type: typeof GET_ONE_INSPECTION
  payload: GetOneInspectionOutDto
}

export interface GetOneInspectionSuccess {
  type: typeof GET_ONE_INSPECTION_SUCCESS
  payload: GetOneInspectionInDto
}

export interface GetOneInspectionError {
  type: typeof GET_ONE_INSPECTION_ERROR
  payload: string | boolean
}

export interface ResetGetOneInspection {
  type: typeof RESET_GET_ONE_INSPECTION
  payload: null
}

export interface State {
  data: GetOneInspectionInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetOneInspection | GetOneInspectionSuccess | GetOneInspectionError | ResetGetOneInspection
